class Orcamento {
    
    constructor(model = null){
        
        this.id = 0;
        this.empresaId = 0;
        this.ano = new Date().getFullYear();
        this.despesa = true;
        this.valor = new OrcamentoValor();
        this.planoContas = [];

        if (!model)
            return;
        
        this.id = model.id ? model.id : 0;
        this.empresaId = model.empresaId;
        this.ano = model.ano;
        this.despesa = model.despesa;
        this.valor = model.valor;
        this.planoContas = model.planoContas;
    }
}

class OrcamentoValor{
    
    constructor(model = null){

        this.janeiro = 0;
        this.fevereiro = 0;
        this.marco = 0;
        this.abril = 0;
        this.maio = 0;
        this.junho = 0;
        this.julho = 0;
        this.agosto = 0;
        this.setembro = 0;
        this.outubro = 0;
        this.novembro = 0;
        this.dezembro = 0;
        this.total = 0;

        if(!model)
            return;

        this.janeiro = model.janeiro;
        this.fevereiro = model.fevereiro;
        this.marco = model.marco;
        this.abril = model.abril;
        this.maio = model.maio;
        this.junho = model.junho;
        this.julho = model.julho;
        this.agosto = model.agosto;
        this.setembro = model.setembro;
        this.outubro = model.outubro;
        this.novembro = model.novembro;
        this.dezembro = model.dezembro;
        this.total = model.total;
    }

    AtualizarTotal(){
        this.total = this.janeiro + this.fevereiro + this.marco + this.abril + this.maio + this.junho + this.julho + this.agosto + this.setembro + this.outubro + this.novembro + this.dezembro;
    }

    ZerarValores(){
        this.janeiro = 0;
        this.fevereiro = 0;
        this.marco = 0;
        this.abril = 0;
        this.maio = 0;
        this.junho = 0;
        this.julho = 0;
        this.agosto = 0;
        this.setembro = 0;
        this.outubro = 0;
        this.novembro = 0;
        this.dezembro = 0;

        this.AtualizarTotal();
    }

}

export { Orcamento, OrcamentoValor }